import React, { useEffect, useState } from 'react';

const THEME_KEY = 'theme';

function getInitialTheme(): 'light' | 'dark' {
  if (typeof window === 'undefined') {
    return 'light';
  }
  const stored = localStorage.getItem(THEME_KEY);
  if (stored === 'dark' || stored === 'light') {
    return stored;
  }
  // Fallback to system preference
  return window.matchMedia('(prefers-color-scheme: dark)').matches ?
    'dark' :
    'light';
}

export const DarkLightSwitcher: React.FC = () => {
  const [theme, setTheme] = useState<'light' | 'dark'>(getInitialTheme);

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  return (
    <button
      onClick={toggleTheme}
      className=
        'p-0 rounded text-white transition-colors mx-2 w-fit'
      aria-label='Toggle dark/light mode'
    >
      {theme === 'dark' ? '☀️' : '🌙'}
    </button>
  );
};

export default DarkLightSwitcher;